/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';

import type {EventCarousel} from './index';

export function template(this: EventCarousel) {
  const image = this.helpers.CAROUSEL_IMAGES[this.state.step];
  return (
    <div sel='.event-carousel'>
      <ButtonEl
        sel='.event-button'
        attrs={{theme: ButtonTheme.Tertiary, icon: `arrow-left`}}
        on={{click: this.helpers.previousStep}}
      />
      <div sel='.event-image'>
        <img sel='.event-image' attrs={{src: image}} />
      </div>
      <ButtonEl
        sel='.event-button'
        attrs={{theme: ButtonTheme.Tertiary, icon: `arrow-right`}}
        on={{click: this.helpers.nextStep}}
      />
    </div>
  );
}
